import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminSession } from "@/modules/auth/context/sessionContext";
import { AppLoadingState } from "@/shared/components/AppLoadingState";

export function AdminRouteGuard({ children }: PropsWithChildren) {
  const { user, loading } = useAdminSession();
  const location = useLocation();
  if (loading) return <AppLoadingState label="Restoring secure admin session…" />;
  if (!user || user.role !== "admin") return <Navigate replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} to="/login" />;
  return children;
}

export function PermissionGuard({ permission, children }: PropsWithChildren<{ permission: string }>) {
  const { can } = useAdminSession();
  if (!can(permission)) return <Navigate replace to="/access-denied" />;
  return children;
}
